import constants from '../helpers/constants.js';
import initialState from './initialState.js';

export default function userDomInfoReducer (state = initialState.userDomInfo, action) {
  switch (action.type) {
    case constants.APPLICATION_THEME :
      return Object.assign({}, state, {theme : action.data});
  
    default:
      return state;
  }
}